import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteChangeHandler() {
  const location = useLocation();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      const current = localStorage.getItem('dropdownDisabled');
      if (current !== 'true') {
        localStorage.setItem('dropdownDisabled', 'false');
        window.dispatchEvent(new Event('dropdownStateChange'));
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}